<app-pias-layout>
    <div pias-layout-content>
        <!-- <app-marketing-review-nav></app-marketing-review-nav> -->

        <div class="mr-shell">

            <!-- ═══════════ Page head ═══════════ -->
            <div class="page-header-section">

                <!-- Left Content -->
                <div class="page-header-left">

                    <div class="header-icon-badge">
                        <mat-icon>insights</mat-icon>
                    </div>

                    <div class="title-wrapper">
                        <h4 class="page-header">
                            Marketing Review
                        </h4>
                        <!-- <p class="page-subtitle">
                            {{ isReviewer
                            ? 'Material submitted for approval. Expand a row to see the files attached to it.'
                            : 'The marketing materials you have raised, including drafts. Expand a row to see its
                            files.' }}
                        </p> -->
                    </div>
                </div>

                <!-- Right Actions — creating is for ad creators, not the reviewing team. -->
              
                @if (!isReviewer) {
                <div class="page-header-right">
                    <button type="button" class="export-btn" (click)="createAd()">
                        <mat-icon>add</mat-icon>
                        Create Ad
                    </button>
                </div>
                }
                

            </div>

            <!-- ═══════════ KPI tiles ═══════════ -->
            <!-- Each tile is a toggle: clicking the selected one clears the filter. -->
            <div class="container-fluid px-0">
                <div class="row g-2">
                    @for (stat of stats; track stat.label) {
                    <div class="col-12 col-sm-6 col-lg-3">
                        <button type="button" class="stat-card" [class]="'stat-card ' + stat.tone"
                            [class.active]="isStatActive(stat)" [attr.aria-pressed]="isStatActive(stat)"
                            (click)="toggleStat(stat)"
                            matTooltip="{{ stat.label }} — {{ stat.value }} of {{ statTotal }} ({{ pctOf(stat.value) }}). Click to filter.">
                            <span class="stat-gauge" [style.background]="ringGradient(stat.value)">
                                <span class="stat-icon-wrap">
                                    <mat-icon>{{ stat.icon }}</mat-icon>
                                </span>
                            </span>
                            <span class="stat-info">
                                <span class="stat-label">{{ stat.label }}</span>
                                <span class="stat-value">{{ stat.value }}</span>
                            </span>
                            <mat-icon class="stat-check">check_circle</mat-icon>
                        </button>
                    </div>
                    }
                </div>
            </div>

            <!-- ═══════════ Filters ═══════════ -->
            <div class="mr-filter-bar">
                <!-- Search -->
                <div class="mr-search-box">
                    <mat-icon class="mr-search-icon">search</mat-icon>

                    <input type="text" class="mr-search-input" placeholder="Search by title or branch"
                        aria-label="Search marketing applications" [(ngModel)]="searchQuery"
                        (ngModelChange)="refreshRows()" />

                    @if (searchQuery) {
                    <button type="button" class="mr-search-clear" aria-label="Clear search" matTooltip="Clear search"
                        (click)="clearSearch()">
                        <mat-icon>close</mat-icon>
                    </button>
                    }
                </div>

                <mat-form-field class="status-field" subscriptSizing="dynamic">
                    <mat-select [(ngModel)]="statusFilter" (ngModelChange)="refreshRows()">
                        <mat-option value="">All Status</mat-option>
                        @for (status of statuses; track status) {
                        <mat-option [value]="status.value">{{ status.label }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @if (isReviewer) {
                <mat-form-field class="status-field" subscriptSizing="dynamic">
                    <mat-select [(ngModel)]="branchFilter" (ngModelChange)="refreshRows()">
                        <mat-option value="">All Branches</mat-option>
                        @for (branch of branches; track branch) {
                        <mat-option [value]="branch">{{ branch }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                }

                @if (hasActiveFilters) {
                <button type="button" class="cancel-btn" (click)="resetFilters()">
                    <mat-icon>close</mat-icon>
                    Cancel
                </button>
                }
            </div>

            @if (setSprinner()) {
            <div class="pias-spinner">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            }

            <!-- ═══════════ Review queue ═══════════ -->
            <!-- One row per submitted advertisement; expanding it lists that ad's own files. -->
            @if (!setSprinner()) {
            <div class="mr-table">
                <div class="mr-table-head">
                    <div>Material</div>
                    <div>Submitted by</div>
                    <div>Branch</div>
                    <div>Status</div>
                    <div class="mr-align-right">Action</div>
                </div>

                @for (row of paginatedRows; track row.ad.id) {
                <div class="mr-table-group">

                    <div class="mr-table-row" [class.is-expanded]="isExpanded(row)" (click)="toggleExpand(row)">

                        <div class="mr-material">
                            <button type="button" class="mr-chevron" [attr.aria-expanded]="isExpanded(row)"
                                [attr.aria-label]="'Toggle files for ' + row.ad.title"
                                (click)="toggleExpand(row, $event)">
                                <mat-icon>{{ isExpanded(row) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                            </button>

                            <span class="mr-material-text">
                                <span class="mr-material-title">{{ row.ad.title }}</span>
                                <span class="mr-material-meta">
                                    {{ row.ad.referenceNo }}
                                    @if (row.ad.submittedOn) {
                                    · submitted {{ row.ad.submittedOn  }}
                                    } @else {
                                    · saved {{ row.ad.createdOn }}
                                    }

                                </span>
                            </span>
                        </div>

                        <div class="mr-submitter">
                            <span class="mr-avatar">{{ row.initials }}</span>
                            <span class="mr-submitter-text">
                                <span class="mr-submitter-name">{{ row.ad.createdBy }}</span>
                                <span class="mr-submitter-rep">{{ row.ad.createdByRepCode || '—' }}</span>
                            </span>
                        </div>

                        <div class="mr-cell-text" [matTooltip]="row.ad.branches.join(', ')">
                            {{ branchLabel(row) }}
                        </div>


                        <div>
                            <app-ad-status-badge [status]="row.ad.status"></app-ad-status-badge>
                        </div>

                        <div class="mr-row-actions">
                            @if (row.ad.status === 'Draft') {
                            <button type="button" class="mr-icon-button" matTooltip="Edit draft"
                                (click)="editApplication (row, $event)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            } @else {
                            <button type="button" class="mr-icon-button" matTooltip="Open in review"
                                (click)="openAd(row.ad, $event)">
                                <mat-icon>rate_review</mat-icon>
                            </button>
                            }
                            @if (row.ad.status === 'Draft') {
                            <button type="button" class="mr-icon-button" matTooltip="Delete draft"
                                aria-label="Delete draft" (click)="deleteDraft(row, $event)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            }
                            <button type="button" class="mr-icon-button" matTooltip="View audit log"
                                (click)="openAudit(row, $event)">
                                <mat-icon>history</mat-icon>
                            </button>
                        </div>
                    </div>

                    <!-- ---- The ad's files ---- -->
                    @if (isExpanded(row)) {
                    <div class="mr-nested">
                        @for (file of row.files; track file.attachment.id) {
                        <div class="mr-nested-row">
                            <div></div>

                            @if (file.thumbnailUrl) {
                            <div class="mr-nested-thumb" [style.background-image]="'url(' + file.thumbnailUrl + ')'">
                            </div>
                            } @else {
                            <div class="mr-nested-thumb is-placeholder" [attr.data-tone]="file.tone">
                                <mat-icon>{{ file.icon }}</mat-icon>
                            </div>
                            }

                            <div class="mr-nested-text">
                                <span class="mr-nested-title">{{ file.attachment.fileName }}</span>
                                <span class="mr-nested-meta">{{ file.meta }}</span>
                            </div>
                        </div>
                        }

                        @if (!row.files.length) {
                        <p class="mr-nested-empty">
                            No files were attached to this application — the copy was submitted on its own.
                        </p>
                        }
                    </div>
                    }
                </div>
                }

                @if (!rows.length) {
                <p class="mr-table-empty">
                    {{ hasActiveFilters
                    ? 'No submissions match the current filters.'
                    : isReviewer
                    ? 'Nothing has been submitted for review yet.'
                    : 'You have not raised any marketing material yet. Use "Create Ad" to start one.' }}
                </p>
                }

                <!-- Paginator: the table's footer, inside the same card. -->
                <div class="mr-table-foot">
                    <mat-paginator [length]="rows.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                        [pageSizeOptions]="[5, 10, 25, 50]" [showFirstLastButtons]="true" (page)="onPageChange($event)"
                        aria-label="Select page of marketing applications">
                    </mat-paginator>
                </div>
            </div>
            }
        </div>
    </div>
</app-pias-layout>